import { render, staticRenderFns } from "./ListOrderSource.vue?vue&type=template&id=2f8240a0&scoped=true"
import script from "./ListOrderSource.vue?vue&type=script&lang=js"
export * from "./ListOrderSource.vue?vue&type=script&lang=js"
import style0 from "./ListOrderSource.vue?vue&type=style&index=0&id=2f8240a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8240a0",
  null
  
)

export default component.exports